import axios from 'axios';
import { RenderStatus } from './finalcut.service';
import { FileStatus } from './file.service';

export interface FinalcutProgressData {
  finalCutId: FinalcutId;
  finalCutVersionId: number;
  percent?: number;
  data?: string;
  status?: RenderStatus;
  errorMessage?: string;
}

export interface FinalcutQueueData {
  finalCutId: FileId;
  positionInQueue: number;
}

export interface FileProgressData {
  fileId: FileId;
  projectId: ProjectId;
  status: FileStatus;
  errorMessage?: string;
  progress?: number;
}

export interface FileQueueData {
  fileId: FileId;
  positionInQueue: number;
}

const PING_DELAY = 120 * 1000;

// S E R V I C E

const { VITE_DOMAIN_RENDER, VITE_DOMAIN_FILE_PROGRESS, VITE_DOMAIN_BASE } = import.meta.env;

const ping = (url: Url) => {
  return axios.get(`${url}/ping`, { timeout: PING_DELAY }) as Promise<boolean>;
};

export const pingFcRenderServer = () => {
  return ping(VITE_DOMAIN_RENDER);
};

export const pingFileProgressServer = () => {
  return ping(VITE_DOMAIN_FILE_PROGRESS);
};

export const pingWebApi = () => {
  return ping(VITE_DOMAIN_BASE);
};

export const subscribeFcRenderServer = async (token: string) => {
  return await new EventSource(`${VITE_DOMAIN_RENDER}/listen-progress?Auth=${token}`);
};

export const subscribeFileProgressServer = async (token: string) => {
  return await new EventSource(`${VITE_DOMAIN_FILE_PROGRESS}/Process/ListenProgress?Auth=${token}`);
};

export const subscribeConnect = async (token: string) => {
  return await new EventSource(`${VITE_DOMAIN_BASE}/MediaFile/Connect?Auth=${token}`);
};
